import React from 'react';
import { twMerge } from 'tailwind-merge';
interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  padding?: 'none' | 'sm' | 'md' | 'lg';
}
export function Card({
  children,
  padding = 'md',
  className,
  ...props
}: CardProps) {
  const paddings = {
    none: '',
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-6 sm:p-8'
  };
  return <div className={twMerge('bg-white rounded-3xl border border-gray-100 shadow-sm', paddings[padding], className)} {...props} data-id="element-42">
      {children}
    </div>;
}